<div class="mat-button-wrapper" (click)="launch(step.id, index, assignment)"  [ngClass]="{'firstLaunch': step.firstLaunch}" appAddClassInRegardOfTextHeight>

  <span [ngClass]="step.firstLaunch?'title first_launch':'title'">{{step.title ? step.title : step.id}}</span>

  <span class="reward-container">
    <!--number of stars-->
    @for (icon of this.stars; track icon) {
      <mat-icon svgIcon="star_1"></mat-icon>
    }
    <!--number of empty icon-->
    @for (icon of this.empty; track icon) {
      <mat-icon svgIcon="star_0"></mat-icon>
    }
    <!--case of diamond win-->
    @if (diamond===1) {
      <mat-icon class="diamond" svgIcon="diamond"></mat-icon>
    }
  </span>

</div>

